import el from "@cypherpotato/el";
import { getUniqueColor } from "../ui/unique-color";
import { cond } from "../util";
import { Icon } from "./icon";

export function Badge(text, color, ...args) {
    return el("span.badge", text, { style: { backgroundColor: color || getUniqueColor(text) } }, ...args);
}

export function IconBadge(icon, text, color, ...args) {
    return el("span.badge", icon, text, { style: { backgroundColor: color || getUniqueColor(text) } }, ...args);
}

export function AgenticTestResultBadge(run) {
    return cond(
        [run?.state?.toLowerCase() == "pending", IconBadge(Icon("zzz-line"), "Pending", "var(--fr-300)")],
        [run?.state?.toLowerCase() == "running", IconBadge(Icon("play-mini-fill"), "Running", "var(--info)")],
        [run?.state?.toLowerCase() == "cancelled", IconBadge(Icon("close-circle-line"), "Cancelled", "var(--fr-300)")],
        [run?.state?.toLowerCase() == "succeeded" && (run?.outcome || run?.result?.outcome)?.toLowerCase() == "success", IconBadge(Icon("check-line"), "Pass", "var(--success)")],
        [run?.state?.toLowerCase() == "succeeded" && ["loss", "incomplete"].includes((run?.outcome || run?.result?.outcome)?.toLowerCase()), IconBadge(Icon("close-circle-line"), "Failed", "var(--warn)")],
        [true, IconBadge(Icon("error-warning-line"), "Error", "var(--warn)")]
    );
}

export function LiveConversationStatusBadge(conversation) {
    return cond(
        [conversation.status == "running", IconBadge(Icon("play-mini-fill"), "Running", "var(--info)")],
        [conversation.status == "persisting", IconBadge(Icon("save-line"), "Saving", "var(--fr-300)")],
        [conversation.conversationId, IconBadge(Icon("check-line"), "Completed", "var(--success)")],
        [true, IconBadge(Icon("close-circle-line"), "Not stored", "var(--warn)")]
    );
}

export function PlanBadge(plan, ...args) {
    const planName = String(plan || "").trim();
    if (!planName) {
        return null;
    }

    return el("img.plan-badge-image", {
        src: `/assets/badge-${planName.toLowerCase()}.svg`,
        alt: `${planName} plan`,
        title: `${planName} plan`
    }, ...args);
}

export function TagBadge(text, ...args) {
    return el("span.tag-badge", text, ...args);
}


export function TagIconBadge(icon, text, color, ...args) {
    return el("span.tag-badge", icon, text, { style: { color: color || getUniqueColor(text) } }, ...args);
}

export function BadgeList(...args) {
    return el("span.badge-list", ...args);
}
